import {
	IRepository,
	SingleUserRepository,
	IsolatedUserRepository
} from "../repository";
import { ZustandStore } from "./models";

export interface IUserDatabaseSession {
	singleUserZustandStores: IRepository<ZustandStore, string>;
	zustandStores: IRepository<ZustandStore, string>;
}

export class UserDatabaseSession implements IUserDatabaseSession {
	public readonly singleUserZustandStores: IRepository<ZustandStore, string>;
	public readonly zustandStores: IRepository<ZustandStore, string>;

	constructor(database: IDBDatabase, userId: number) {
		this.singleUserZustandStores = new SingleUserRepository<ZustandStore, string>(
			database,
			"singleUserZustandStores",
			userId
		);

		this.zustandStores = new IsolatedUserRepository<ZustandStore, string>(
			database,
			"zustandStores",
			userId
		);
	}
}